import cloneDeep from 'lodash/cloneDeep';
import {
  fetchMatchesRequest,
  updateMatchesRequest,
  createMatchesRequest,
} from './matches-request.service';

export default {
  namespaced: true,
  state: {
    id: null,
    startDate: null,
    schedule: null,
    scheduleDays: [],
    scheduleNeedsNotes: null,
    address: null,
    excludedFacilitiesNotes: null,
    dependents: null,
    requestStatus: 'in_progress',
    openMatchesForm: false,
  },
  mutations: {
    setState: (state, data) => {
      Object.keys(data).forEach((key) => {
        state[key] = data[key];
      });
    },
    setOpenMatchesForm(state, value) {
      state.openMatchesForm = value;
    },
  },
  actions: {
    async fetchMatchesRequest({ commit, dispatch }) {
      try {
        const response = await fetchMatchesRequest();
        await commit('setState', response);
      } catch (error) {
        dispatch('notifications/addToastError', {
          text: 'Could not load matches request',
          error,
        }, { root: true });
      }
    },
    async saveMatchesRequest({ dispatch, commit }, data) {
      try {
        const newData = cloneDeep(data);
        await commit('setState', newData);
        if (newData.id) {
          const response = await updateMatchesRequest(newData);
          await commit('setState', response);
        } else {
          const response = await createMatchesRequest(newData);
          await commit('setState', response);
        }
      } catch (error) {
        dispatch('notifications/addToastError', {
          text: 'Could not save matches request',
          error,
        }, { root: true });
      }
    },
  },
};
